// extracted by mini-css-extract-plugin
export default {"Label":"tracks-label-module__Label--FoN6J","Text":"tracks-label-module__Text--AVELy"};